<template>
  <div class="process-box center-content-border" >
    <el-tabs ref="tabRef" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="item in tabList" :key="item.type" :label="item.name" :name="item.type"> </el-tab-pane>
    </el-tabs>
    <div class="process-content">
      <ul class="list-item" v-if="list && list.length" v-loading="loading">
        <li v-for="(item, index) in list" :key="index" @click="toDetailpage(item)"> 
          <div class="title">
          {{ item.processInstanceDTO&&item.processInstanceDTO.processInstanceTitle || item.processInstanceTitle}}
          </div>
          <div class="date">{{(item.processInstanceDTO&&item.processInstanceDTO.createTime || item.createTime) | subStrDate}}</div>
        </li>
      </ul>
      <div class="no-result" v-else>暂无数据</div>
      <div class="page" v-if="list && list.length">
        <el-pagination
        small
        :page-size="20"
        :pager-count="7"
        layout="prev, pager, next"
        :current-page.sync="pageNo"
        @current-change="handleCurrentChange"
        :total="total">
      </el-pagination> 
      </div>
    </div>
  </div>
</template>

<script>
import { getAssignList, getDoneList, getMyList } from '@/util/api'
import {formatDate} from '@/util/date'

export default { 
  data() {
    return {
      activeName: 'assign',
      pageNo: 1,
      limit: 20,
      total: 0,
      list: [],
      loading: false
    }
  },
  computed: {
    tabList() {
      return [
        {name: '待办', type: 'assign'},
        {name: '已办', type: 'done'},
        {name: '完成', type: 'finish'},
        {name: '我的申请', type: 'apply'}
      ]
    },
    user() {
      return this.$store.state.user.user
    },
    uid() {
      return this.user.uid || ''
    }
  },
  mounted() { 
    this.getAssign()
  },
  filters: {
    // 处理服务器返回的时间 保留date不要time
    subStrDate(val) {
      return val && typeof val === 'string' ? 
        val.substr(0 ,10) : val && typeof val === 'number' ?
        formatDate(val, 'yyyy-MM-dd'): ''
    }
  },
  methods: {
    resetTabActivePosition($el) {
      setTimeout(() => {
        var activeEl = $el.querySelector('.el-tabs__item.is-active');
        var lineEl = $el.querySelector('.el-tabs__active-bar');
        var style = getComputedStyle(activeEl);
        var pl = style.paddingLeft.match(/\d+/)[0] * 1;
        var pr = style.paddingRight.match(/\d+/)[0] * 1;
        var w = style.width.match(/\d+/)[0] * 1;
        lineEl.style.transform = 'translateX(' + (activeEl.offsetLeft + pl) + 'px)';
        lineEl.style.width = (w - pl - pr)+'px';
      }, 0)
    },
    toDetailpage(item) {
      let url = item.processInstanceDTO&&item.processInstanceDTO.callbackPath || item.callbackPath
      window.open(url)
    },
    handleClick(tab) {
      this.pageNo = 1
      this.changeTabDatas(tab.name)
    },
    changeTabDatas(name) {
      switch (name) {
        case 'assign':
          this.getAssign()
          break
        case 'done':
          this.getDone()
          break
        case 'finish':
          this.getDone(1)
          break
        case 'apply':
          this.getApply()
          break
        default:
      }
    },
    getAssign() {
      this.loading = true
      let params = {
        pageNo: this.pageNo,
        limit: this.limit, 
        uid: this.uid
      }
      getAssignList( params).then(res => {
        this.loading = false
        if (res.code == 0) {
          this.list = res.data.records || []
          this.total = res.data.total || 0
        } else {
          this.list = []
          this.total = 0
        }
      }).catch(() => {
        this.loading = false
      })
    },
    getDone(status) {
      this.loading = true
      let params = {
        pageNo: this.pageNo,
        limit: this.limit, 
        uid: this.uid,
        processStatus: status // 流程状态(全部:0 完成:1 未完成:2)
      }
      getDoneList(params).then(res => {
        this.loading = false
        if (res.code == 0) {
          this.list = res.data.records || []
          this.total = res.data.total || 0
        } else {
          this.list = []
          this.total = 0
        }
      }).catch(() => {
        this.loading = false
      })
    },
    getApply() {
      this.loading = true
      let params = {
        pageNo: this.pageNo,
        limit: this.limit, 
        uid: this.uid
      }
      getMyList( params).then(res => {
        this.loading = false
        if (res.code == 0) {
          this.list = res.data.records || []
          this.total = res.data.total || 0
        } else {
          this.list = []
          this.total = 0
        }
      }).catch(() => {
        this.loading = false
      })
    }, 
    handleCurrentChange(val) {
      this.pageNo = val
      this.changeTabDatas(this.activeName)
    }
  }
}
</script>

<style scoped lang="less">
.process-box{
  margin: 0 14px 10px 20px;

  /deep/ .el-tabs{ 
    .el-tabs__nav{
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    .el-tabs__item{
      font-size: 16px;
      height: 37px;
      padding-bottom: 2px;
      color: @title-color;
      flex: 0 0 25%;
      text-align: center;
      font-weight: normal;
      display: inline-block; 
    }
    .el-tabs__header{
      margin-bottom: 0;
      height: 37px;
    }
    .el-tabs__active-bar{
      width: 25%;
      background-color: @theme-color;
      text-align: center;
    }
    .el-tabs__item{
      &:hover,&.is-active{
        color: @theme-color;
      }
    }
  }
  /deep/ .el-tabs__nav-wrap::after{
    background-color: @default-border-color;
    height: 1px;
    width: 100%;
  }
  .process-content{
    min-height: 224px;
    height: 28vh;
    padding-top: 12px;
  }
  .list-item{
    min-height: 192px;
    height: 24vh;
    overflow: auto;
    width: 100%;
    li{
      display: flex;
      flex-direction: row;
      cursor: pointer;
      font-size: 14px;
      color: @li-text-color;
      width: calc(100% - 60px);
      margin-top: 8px;
      overflow: hidden;
      padding-left: 30px;
      padding-right: 30px;
      justify-content: space-between;
      &:first-child{
        margin-top:0;
      }
      .title{
        overflow:hidden;
        white-space: nowrap;
        margin-right: 20px;
      }
      .date{
        text-align: right;
        white-space: nowrap;
      }
    }
  }
  .page{
    text-align: center;
    padding-top: 4px;
    /deep/ .el-pagination{
      height: 32px;
      line-height: 32px;
    }
    /deep/ .el-pager li{
      font-weight: normal;
      color: @text-color;
      font-size: 12px;
      &:hover,&.active {
        color: @theme-color;
      }
    }
  }
}
</style>
